import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Form } from 'react-final-form';
import PropTypes from '../../../types';
import { Content } from '../../../infrastructure/content';
import GDPREmail from './GDPREmail';
import GDPRInternet from './GDPRInternet';
import GDPRMessaging from './GDPRMessaging';
import GDPRPhone from './GDPRPhone';
import GDPRPost from './GDPRPost';
import { checkEmptyFieldValue, getAnchorTag, getHyperlink, onKeyPress } from '../../../utils';
import Submit from '../../../components/Submit';

class GDPRQuestionPage extends Component {
  constructor() {
    super();
    this.state = {
      isSuccessModalOpen: false
    };
    this.openThenCloseSuccessModal = this.openThenCloseSuccessModal.bind(this);
    this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
    this.saveGDPRForm = this.saveGDPRForm.bind(this);
  }

  toggleSuccessModal() {
    this.setState({ ...this.state, isSuccessModalOpen: !this.state.isSuccessModalOpen });
  }
  openThenCloseSuccessModal() {
    this.toggleSuccessModal();
    setTimeout(this.toggleSuccessModal, this.modalDelay);
  }
  saveGDPRForm(data) {
    const businessUpdate = checkEmptyFieldValue(this.props.businessUpdateId)
      ? this.props.businessUpdateId
      : this.props.businessId;
    this.props.saveGDPRForm(data, businessUpdate, this.props.caseId, this.props.caseType);
    this.openThenCloseSuccessModal();
  }
  render() {
    const { bankId, getBusinessData, marketingLoader } = this.props;

    return (
      <Form
        onSubmit={this.saveGDPRForm}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit} onKeyPress={onKeyPress}>
            <Content>
              {({
                gdprHeader = '',
                gdprOffersPartA,
                gdprOffersPartBlinkVM,
                gdprOffersPartC,
                gdprOffersPartD,
                gdprPartnersAndProcessingPartA,
                gdprPartnersAndProcessingPartBpartnersLinkVM,
                gdprPartnersAndProcessingPartC,
                gdprPartnersAndProcessingPartD,
                fairProcessingNoticeLinkCB,
                fairProcessingNoticeLinkYB,
                fairProcessingNotice,
                gdprModalUpdated,
                gdprPreferences
              }) => (
                <div>
                  <PageHeading>{gdprHeader}</PageHeading>
                  <StandardBody>
                    <p>
                      {gdprOffersPartA}
                      {getAnchorTag(gdprOffersPartC, gdprOffersPartBlinkVM)}
                      {gdprOffersPartD}
                    </p>
                  </StandardBody>
                  {marketingLoader && (
                    <Modal isOpen={true} size="md">
                      <div className="u-text-align-center u-margin-2">
                        <Icon iconType="TickSolidSmall" backingSize="xl" />
                        <p className="u-margin-top-2">{gdprModalUpdated}</p>
                      </div>
                    </Modal>
                  )}
                  <GDPREmail values={values} />
                  <GDPRInternet values={values} />
                  <GDPRMessaging values={values} />
                  <GDPRPhone values={values} />
                  <GDPRPost values={values} />
                  <StandardBody>
                    <p>{gdprPreferences}</p>
                    <p className="u-margin-bottom-6">
                      {gdprPartnersAndProcessingPartA}
                      {getAnchorTag(
                        gdprPartnersAndProcessingPartC,
                        gdprPartnersAndProcessingPartBpartnersLinkVM
                      )}
                      {gdprPartnersAndProcessingPartD}
                      {getAnchorTag(
                        fairProcessingNotice,
                        getHyperlink(fairProcessingNoticeLinkCB, fairProcessingNoticeLinkYB, bankId)
                      )}
                    </p>
                  </StandardBody>
                </div>
              )}
            </Content>
            <Submit />
          </form>
        )}
      />
    );
  }
}
GDPRQuestionPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveGDPRForm: PropTypes.func.isRequired
};
GDPRQuestionPage.defaultProps = {
  modalDelay: 3000
};
export default GDPRQuestionPage;
